import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getDashboardData } from "../../../redux/dashboardSlice";
import { http_get } from "../utils/api_client";
import { API_ENDPOINTS } from "../utils/endpoints";
import AudienceGrowth from "./widgets/AudienceGrowth";
import CompletionByPath from "./widgets/CompletionByPath";
import WhatsWorking from "./widgets/WhatsWorking";
import RecentActivity from "./widgets/RecentActivity";
import NeedsAttention from "./widgets/NeedsAttention";
import DropoffFunnel from "./widgets/DropoffFunnel";
import "./Dashboard.scss";

function DashboardBody() {
  const dash = useSelector(getDashboardData); // { data, filterType, customDate }
  const option = dash.filterType || "all_time";
  const customDate = dash.customDate;

  const [widgets, setWidgets] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    const params = { option };
    if (option === "custom_date" && customDate) {
      params.custom_date = { start_date: customDate.start_date, end_date: customDate.end_date };
    }
    http_get(API_ENDPOINTS.GET_DASHBOARD_WIDGETS, params)
      .then(({ data }) => { if (alive) setWidgets(data); })
      .catch(() => { if (alive) setWidgets(null); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [option, customDate && customDate.start_date, customDate && customDate.end_date]);

  return (
    <div className="dashv2">
      <AudienceGrowth core={dash.data} breakdown={widgets && widgets.growth_breakdown} loading={loading} />

      <NeedsAttention />

      {/* Row A (mockup): drop-off funnel + recent activity. Funnel shows its
          empty state until the computation lands (Phase 5, BL-086/087). */}
      <div className="dv-row2">
        <DropoffFunnel />
        <RecentActivity items={widgets && widgets.recent_activity} loading={loading} />
      </div>

      {/* Row B (mockup): what's working + completion by path */}
      <div className="dv-row2">
        <WhatsWorking data={widgets && widgets.whats_working} loading={loading} />
        <CompletionByPath rows={widgets && widgets.completion_by_path} loading={loading} />
      </div>
    </div>
  );
}

export default DashboardBody;
